import {ProcessedTripItinerary, TourCatalog, TourOperator} from "../contentfulModel.ts";
import React from "react";
import {getTickIcon, renderRichText, RichTextNode} from "../utils.tsx";
import CatalogStartIcon from "../../assets/icons/catalogStartIcon.png";

interface ItineraryDetailsPDFProps {
    tourPackage: ProcessedTripItinerary;
    tourOperator: TourOperator;
    tourCatalog: TourCatalog
}

export const ItineraryDetailsPDF : React.FC<ItineraryDetailsPDFProps> = ({
    tourPackage,
    tourOperator,
    tourCatalog
}) => {
    return (
        <div className="flex flex-col" style={{
            aspectRatio:  1.4136,
            height:"29.71cm",
            width: "42cm"
        }}>
        <div className="w-full min-h-[450px] max-h-[450px]" style={{
            backgroundImage: `url(${tourPackage?.mainImage.file?.includes(" ") ? encodeURI(tourPackage?.mainImage.file) : tourPackage?.mainImage.file})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: 0
        }}>
            {/* Content without filter */}
            <div className="relative z-10 text-white p-10 py-6 h-full flex flex-col w-full justify-between">
                <div className="flex flex-row justify-between">
                    <div className="text-lg font-light  text-start">{tourPackage.name}</div>
                    <div className="flex justify-end">
                        <div className="uppercase text-lg font-light text-start"
                             style={{color: 'white'}}>{tourOperator.name}</div>
                    </div>
                </div>
                <div className="flex items-center justify-end gap-4">
                    <div className="rounded-full px-6 py-4  font-medium text-2xl uppercase" style={{
                        color: tourOperator.primaryColor || "#000000",
                        fontSize: "22pt",
                        lineHeight: "22pt",
                        background: "rgba(255, 255, 255, 0.9)"

                    }}>{tourPackage.subtitle || tourPackage.itinerary.length - 1 + " NOCHES"}
                    </div>
                    {tourPackage.price && (
                        <div className="rounded-full px-6 py-2  font-medium text-2xl" style={{
                            color: tourOperator.primaryColor || "#000000",
                            fontSize: "20pt",
                            lineHeight: "18pt",
                            background: "rgba(255, 255, 255, 0.9)"
                        }}>
                            <div className="text-[10pt] uppercase font-light">Desde</div>
                            <div>{tourPackage.price}</div>
                        </div>)}
                </div>
            </div>
        </div>
            <div className="h-[70%] flex flex-row px-12 py-10 gap-40">
                <div className="w-[50%] h-full">
                    <div className="flex flex-col">
                        <div className="flex flex-col">
                            <div className="font-bold text-2xl text-start" style={{
                                color: tourOperator.primaryColor || "#000000",
                            }}>{tourPackage.name}
                            </div>
                        </div>
                        <div className="flex flex-row gap-5 mt-8">
                            <div className="flex flex-col max-w-1/2">
                                <div className="font-bold text-[14px] text-start mb-2" style={{
                                    color: tourOperator.primaryColor || "#000000",
                                }}>Incluye
                                </div>
                                <div>
                                {tourPackage.termsAndPricing?.includes && (
                                        <ul className="md:text-md space-y-2">
                                            {tourPackage.termsAndPricing.includes.map((item, index) => (
                                                <li key={index} className="flex items-start gap-3 mb-3 f-wull">
                                                    <div className="min-h-1 min-w-1 rounded-full mt-2" style={{
                                                        background: "rgba(0, 0, 0, 0.8)"
                                                    }}/>
                                                    <div
                                                        className="text-start text-xs font-light"
                                                        style={{
                                                            fontSize: "10pt",
                                                            lineHeight: "12pt",
                                                            color: "rgba(0, 0, 0, 0.8)"
                                                        }}>{item}</div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-col max-w-1/2">
                                <div className="font-bold text-[14px] text-start mb-2" style={{
                                    color: tourOperator.primaryColor || "#000000",
                                }}>No Incluye
                                </div>
                                <div>
                                    {tourPackage.termsAndPricing?.noIncludes && (
                                        <ul className="md:text-md space-y-2">
                                            {tourPackage.termsAndPricing.noIncludes.map((item, index) => (
                                                <li key={index} className="flex items-start gap-3 mb-3">
                                                    <div className="min-h-1 min-w-1 rounded-full mt-2" style={{
                                                        background: "rgba(0, 0, 0, 0.8)"
                                                    }}/>
                                                    <div
                                                        className="flex-grow text-black text-start text-xs font-light"
                                                        style={{
                                                            fontSize: "10pt",
                                                            lineHeight: "12pt",
                                                            color: "rgba(0, 0, 0, 0.8)"

                                                        }}>{item}</div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="w-[50%] h-full">
                    <div className="flex flex-col">
                        <div className="flex flex-col hidden">
                            <div className="font-bold text-2xl text-start" style={{
                                color: tourOperator.primaryColor || "#000000",
                            }}>Hoteles
                            </div>
                            <div className="min-h-[200px] max-h-[200px] mt-4 overflow-hidden">
                                <div className="grid grid-cols-2 gap-1 gap-x-14">
                                    {
                                        false && tourPackage.hotels?.map((hotel, index) => {
                                            const matchedHotel = tourCatalog.hotels.find((hot) => hot.name === hotel.name);
                                            const rating = matchedHotel?.rating || 0;

                                            return (
                                                <div key={index}
                                                     className="text-black flex flex-row items-center gap-2 mb-2">
                                                    <div className="text-[12pt] text-black font-bold flex-1 text-start max-w-[180px]">
                                                        {hotel.name}
                                                    </div>
                                                    <div className="flex flex-shrink-0">
                                                        {Array.from({length: rating}).map((_, starIndex) => (
                                                            <img key={starIndex} className="w-6 h-6"
                                                                 src={CatalogStartIcon} alt="Star"/>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="font-bold text-2xl text-start mb-0" style={{
                                color: tourOperator.primaryColor || "#000000",
                            }}>Observaciones
                            </div>
                            <div className="text-black text-start text-[12px]">
                                {tourPackage.termsAndPricing.observations &&
                                    <ul className="md:text-md space-y-2 mt-2">
                                        {tourPackage.termsAndPricing.observations.map((item, index) => (
                                            <li key={index} className="flex items-start gap-3 mb-3">
                                                <div
                                                    className="flex-grow text-black text-start text-xs font-light"
                                                    style={{
                                                        fontSize: "10pt",
                                                        lineHeight: "12pt",
                                                        color:"rgba(0, 0, 0, 0.8)"

                                                    }}>{item.text}</div>
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
